import React, { useState } from 'react'
import MobileBanner from '../../../../Mobile/User/MobileGlobalComponents/MobileBanner/MobileBanner'
import CustomTextField from '../../../../../customComponents/CustomTextField'
import withOrderTreeData from './HOCs/withOrderTreeData'
import ReferralCommTreeInner from './ReferralCommTreeInner'

const ReferralCommTreeMobile = (props) => {
	// const [expandedUsers, setExpandedUsers] = useState([])

	// const handleClick = (event, userId) => {
	// 	event.preventDefault()
	// 	setExpandedUsers((prev) => (prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]))
	// }

	// const renderTree = (data) => {
	// 	if (!data || data.length === 0) {
	// 		return <p>No matching users found</p>
	// 	}

	// 	return (
	// 		<div
	// 			className='tree-container'
	// 			style={{
	// 				display: 'flex',
	// 				flexDirection: 'column',
	// 				alignItems: 'center',
	// 				position: 'relative',
	// 				padding: '20px 0',
	// 			}}
	// 		>
	// 			{data.map((user) => (
	// 				<div
	// 					key={user._id}
	// 					style={{
	// 						display: 'flex',
	// 						flexDirection: 'column',
	// 						alignItems: 'center',
	// 						position: 'relative',
	// 						marginBottom: '30px',
	// 					}}
	// 				>
	// 					<div
	// 						style={{
	// 							border: '1px solid #ddd',
	// 							borderRadius: '8px',
	// 							padding: '15px',
	// 							background: '#fff',
	// 							display: 'flex',
	// 							flexDirection: 'column',
	// 							alignItems: 'center',
	// 							gap: '8px',
	// 							minWidth: '120px',
	// 							position: 'relative',
	// 						}}
	// 					>
	// 						<img
	// 							src={
	// 								user.gender === 'male'
	// 									? 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/kal-visuals-square.jpg'
	// 									: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/team-3.jpg'
	// 							}
	// 							alt={user.fullName}
	// 							style={{
	// 								width: '50px',
	// 								height: '50px',
	// 								borderRadius: '50%',
	// 								border: '2px solid #eee',
	// 							}}
	// 						/>
	// 						<div
	// 							style={{
	// 								textAlign: 'center',
	// 								fontSize: '14px',
	// 								fontWeight: '500',
	// 							}}
	// 						>
	// 							{user.registerId}
	// 						</div>
	// 						{user.level && (
	// 							<div
	// 								style={{
	// 									fontSize: '12px',
	// 									color: '#666',
	// 									padding: '2px 8px',
	// 									borderRadius: '12px',
	// 									background: '#f5f5f5',
	// 								}}
	// 							>
	// 								Level: {user.level}
	// 							</div>
	// 						)}
	// 					</div>

	// 					{/* Recursively Render Children */}
	// 					{expandedUsers.includes(user._id) && user.users && user.users.length > 0 && (
	// 						<div
	// 							style={{
	// 								display: 'flex',
	// 								gap: '40px',
	// 								paddingTop: '30px',
	// 								position: 'relative',
	// 								borderTop: '2px solid #ddd',
	// 								marginTop: '15px',
	// 							}}
	// 						>
	// 							{user.users.map((childUser) => (
	// 								<div key={childUser._id}>
	// 									{/* Render child recursively */}
	// 									{renderTree([childUser])}
	// 								</div>
	// 							))}
	// 						</div>
	// 					)}

	// 					{!expandedUsers.includes(user._id) && user.users && user.users.length > 0 && (
	// 						<button
	// 							onClick={(e) => handleClick(e, user._id)}
	// 							style={{
	// 								border: 'none',
	// 								background: 'none',
	// 								cursor: 'pointer',
	// 								marginTop: '10px',
	// 								color: '#666',
	// 							}}
	// 						>
	// 							+ Show {user.users.length} Members
	// 						</button>
	// 					)}
	// 				</div>
	// 			))}
	// 		</div>
	// 	)
	// }

	return (
		// <div className='container-fluid px-3 py-4' style={{ minHeight: '100vh' }}>
		// 	<MobileBanner />
		// 	<div className='card mt-n4' style={{ boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)' }}>
		// 		<div className='card-body' style={{ padding: '20px' }}>
		// 			<h5 className='card-title mb-4' style={{ fontSize: '18px', fontWeight: 'bold' }}>
		// 				Referral Commission Tree
		// 			</h5>
		// 			{/* <div className='mb-3'>
		// 				<CustomTextField
		// 					type='text'
		// 					placeholder='Search by User ID...'
		// 					value={searchTerm}
		// 					onChange={(e) => handleSearch(e.target.value)}
		// 					fullWidth
		// 				/>
		// 			</div> */}
		// 			<div
		// 				style={{
		// 					overflowX: 'auto',
		// 					overflowY: 'auto',
		// 					maxHeight: '70vh',
		// 					WebkitOverflowScrolling: 'touch',
		// 					padding: '20px 10px',
		// 					margin: '0 -10px',
		// 				}}
		// 			>
		// 				<div
		// 					style={{
		// 						minWidth: 'fit-content',
		// 						display: 'flex',
		// 						justifyContent: 'center',
		// 					}}
		// 				>
		// 					{renderTree(orderTreeData)}
		// 				</div>
		// 			</div>
		// 		</div>
		// 	</div>
		// </div>
		<div>
			<ReferralCommTreeInner {...props} />
		</div>
	)
}

export default //  withOrderTreeData
ReferralCommTreeMobile
